export interface SvgIcon {
  name: string;
  svg: string;
  height?: string;
  width?: string;
}

export function createIconDefinition(name: string, svg: string): SvgIcon {
  return {
    name,
    svg: removeColors(svg),
    height: getHeight(svg),
    width: getWidth(svg),
  };
}

function getWidth(svg: string) {
  const width = svg.match(/width=['"]([^'"]*)['"]/)?.[1];
  return width ? `${width}px` : undefined;
}

function getHeight(svg: string) {
  const height = svg.match(/height=['"]([^'"]*)['"]/)?.[1];
  return height ? `${height}px` : undefined;
}

function removeColors(svg: string) {
  return svg
    .replace(/\s*fill=['"][^'"]*['"]/g, '')
    .replace(/\s*fill-opacity=['"][^'"]*['"]/g, '');
}
